import {Graphics} from "@dp-instant/ui";
import * as confirm_icon from "@assets/confirm-icon.svg";
import {IClickableComponentProps} from "@game/ui/interface/IClickableComponentProps";
import cn from "classnames";
import {playUIClickSound} from "@game/helpers";
import {hapticMedium} from "@game/haptic";

export const ConfirmButton = (props: IClickableComponentProps) => (
    <button
        className={cn("btn", "btn-green", "confirm-button")}
        onClick={() => {
            if (props.onClick) {
                playUIClickSound();
                hapticMedium();
                props.onClick();
            }
        }}
        type="button"
    >
        <Graphics svg={confirm_icon} inline={false} />
    </button>
);
